import axios from "axios";
import { base_url } from "../../../constants/routes";
let pagesize = 20;
let pagenum = 0;
export function saveCustomer(customer) {
  return axios
    .post(base_url + "/customer", customer)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export function findAllCustomer(page) {
  let newurl = base_url;
  console.log(page);
  newurl += `/customer/${pagesize}/${page}`;
  return axios
    .get(newurl)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err.response.status == 401 && localStorage.getItem("token")) {
        localStorage.removeItem("token");
        window.location.href = "/";
      }
      console.log(err);
      return [];
    });
}

export function updateCustomer(query, update) {
  return axios
    .put(base_url + "/customer" + "/" + query._id, update)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export function updateAddress(query, address) {
  if (query.orders !== undefined) {
    delete query.orders;
  }
  return axios
    .put(base_url + "/customer" + "/" + query._id + "/add_address", {
      address: address,
    })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export function updateOrder(query, order) {
  return axios
    .put(base_url + "/customer" + "/" + query._id + "/add_order", order)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export function removeOrder(query) {
  return axios
    .get(base_url + "/customer" + "/" + query._id + "/remove_order")
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export function removeAddress(query, address) {
  // $pull removes all values matching a value or even any NeDB query from the array
  return axios
    .put(base_url + "/customer" + "/" + query._id + "/remove_address", address)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export function updateOrders(query, orders) {
  return axios
    .put(base_url + "/customer" + "/" + query._id + "/add_order", orders)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}
